import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import Head from "../Global/Head";
import { fetchData } from "../../services/getQuestions";
import Questions from "../main/stepperQuestions/Questions";
import { Link, useNavigate } from "react-router-dom";
import StartPage from "../main/quizStartPage/StartPage";
import NavNotificationBellIcon from "../shared/navNotificationIcon/NavNotificationBellIcon";
import NavProfileIcon from "../shared/navProfileIcon/NavProfileIcon";
import LoginModal from "../main/loginModal/LoginModal";


const QuestionAnswer = () => {


  const [questions, setQuestions] = useState([]);
  const [startQuiz, setStartQuiz] = useState(false);
  const accessToken = localStorage.getItem("@user");
  const navigate = useNavigate();

  const getQuestions = async () => {
    try {
      const result = await fetchData();
      setQuestions(result?.items);

    } catch (error) {
      console.log("Error in fetching data====>", error);
    }
  };

  
const [isVisible, setIsVisible] = useState(false);
  const [mobileSearchBar, setMobileSearchBar] = useState(false);
  const [topPosition, setTopPosition] = useState(50);

  useEffect(() => {
    let interval;
    const totalTime = 1500;
    const steps = 800;
    const intervalTime = totalTime / steps;
    const decrement = 1300 / steps;

    const increment = 1300 / steps;

    if (!isVisible) {
      interval = setInterval(() => {
        setTopPosition((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            return 0;
          }
          return prev - decrement;
        });
      }, intervalTime);
    }

    return () => clearInterval(interval);
  }, [isVisible]);

  const slideGoDown = () => {
    const totalTime = 1500; // Total animation time
    const steps = 800; // Number of steps
    const intervalTime = totalTime / steps; // Time per step
    const increment = 1300 / steps; // Position change per step

    let interval = setInterval(() => {
      setTopPosition((prev) => {
        if (prev >= 80) {
          clearInterval(interval); // Stop the interval
          setTimeout(() => setIsVisible(false), 0); // Change state after animation ends
          return 80; // Ensure it stops at the original position
        }
        return prev + increment; // Increment position to slide down
      });
    }, intervalTime);
  };

  const BlankModal = ({ isVisible, setIsVisible }) => {
    return (
      <div
        className={`fixed inset-0 z-[1000]  transition-opacity duration-300 ${
          isVisible ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
      >
        <div
          className="absolute inset-0 login-slide-up  bg-black"
          onClick={() => setIsVisible(false)}
        ></div>
        <div className="relative w-full h-screen">
          <div
            style={{ top: `${topPosition}%` }} // Dynamic top position
            className="absolute w-full h-screen transition-none"
          >
            <LoginModal setIsVisible={setIsVisible} slideGoDOwn={slideGoDown} />
          </div>
        </div>
      </div>
    );
  };
  return (
    <div>
      <BlankModal setIsVisible={setIsVisible} isVisible={isVisible} />
      <ToastContainer />
      <Head />
      <div className="navbar-no-shadow shadow-xl mb-10 rounded-b-3xl">
      <div className="w-embed">
        <div
          data-animation="default"
          data-collapse="medium"
          data-duration={400}
          data-easing="ease"
          data-easing2="ease"
          role="banner"
          className="navbar-no-shadow-container w-nav"
        >
          <div className="container-regular">
            <div className="navbar-wrapper">
              <Link to="/" className="navbar-brand hide-mobile w-nav-brand">
                <img
                  loading="lazy"
                  src="/images/Frame-1.svg"
                  alt="Hightable_logo"
                  className="hightable-logo"
                />
              </Link>
              <Link to="/" className="navbar-brand hide-desktop w-nav-brand">
                <img
                  loading="lazy"
                  src="/images/symbolic_logo-1.svg"
                  alt="Hightable_logo"
                  className="hightable-logo"
                />
              </Link>
           
              <nav role="navigation" className="nav-menu-wrapper w-nav-menu">
                <ul role="list" className="nav-menu w-list-unstyled">
                  <li className="mobile-margin-top-10">
                    <div className="nav-button-wrapper">
                      <div className="nav-button nav-icon" />
                      <div
                        data-delay={300}
                        data-hover="true"
                        data-w-id="8a23e3a0-0bf3-850e-05da-75357fc8f500"
                      >
                        {/* <div className="navbar_dropdown-toggle w-dropdown-toggle">
                        <div className="nav-icon">
                          <div className="user notification" />
                        </div>
                      </div> */}
                        {accessToken ? <NavNotificationBellIcon /> : null}
                      </div>
                      <div
                        data-delay={300}
                        data-hover="true"
                        data-w-id="8a23e3a0-0bf3-850e-05da-75357fc8f54c"
                        className="navbar_menu-dropdown w-dropdown"
                      >
                        <NavProfileIcon setIsVisible={setIsVisible} />
                      </div>
                    </div>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
      {!startQuiz && !localStorage.getItem("@userPhone") ? (
        <StartPage
          onStart={() => {
            getQuestions();
            setStartQuiz(true);
          }}
        />
      ) : (
        <Questions quizData={questions} />
      )}
    </div>
  );
};

export default QuestionAnswer;
